/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React from 'react';
import { Tabs, Typography, Button, Row, Col } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';

export type AccessSubTab = 'overview' | 'users' | 'frequency' | 'avg_time';
export type AccessPeriod = 'today' | 'this_month' | 'this_year' | 'last_30_days' | 'last_12_months' | 'last_3_years' | 'custom' | 'all';

interface AccessFilterHeaderProps {
  activeMainTab: 'profile' | 'access';
  onMainTabChange: (val: 'profile' | 'access') => void;
  onExportExcel?: () => void;
  exportLoading?: boolean;
  exportDisabled?: boolean;
}

export const AccessFilterHeader: React.FC<AccessFilterHeaderProps> = ({
  activeMainTab,
  onMainTabChange,
  onExportExcel,
  exportLoading = false,
  exportDisabled = false,
}) => {
  return (
    <div css={containerStyle}>
      {/* 1. Page Title: THỐNG KÊ */}
      <Row css={boxStyles} justify='space-between' align='middle'>
        <Col>
          <Typography.Title css={titleStyles} level={5}>
            THỐNG KÊ
          </Typography.Title>
        </Col>
      </Row>

      {/* 2. Top Tabs: Hồ sơ | Lượt truy cập */}
      <div css={tabsRowStyle}>
        <Tabs
          activeKey={activeMainTab}
          onChange={(key) => onMainTabChange(key as 'profile' | 'access')}
          css={tabStyle}
        >
          <Tabs.TabPane tab="Hồ sơ" key="profile" />
          <Tabs.TabPane tab="Lượt truy cập" key="access" />
        </Tabs>
      </div>

      {/* 3. Section Bar: Thống kê Lượt truy cập & Xuất báo cáo Excel */}
      <div css={headerBarBoxStyle}>
        <Typography.Title css={headerTitleStyle} level={4}>
          Thống kê Lượt truy cập
        </Typography.Title>
        <Button
          type="primary"
          icon={<FileExcelOutlined />}
          style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', fontWeight: 500 }}
          onClick={onExportExcel}
          loading={exportLoading}
          disabled={exportLoading || exportDisabled}
        >
          {exportLoading ? 'Đang xuất...' : 'Xuất báo cáo Excel'}
        </Button>
      </div>
    </div>
  );
};

const boxStyles = css`
  padding: 1rem;
  background: var(--white-color);
  box-shadow: 0.02rem 0.04rem 0.2rem var(--gray-light-color);
  margin-bottom: 1rem;
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
`;

const containerStyle = css`
  margin-bottom: 0;
`;

const tabsRowStyle = css`
  margin-bottom: 12px;
`;

const tabStyle = css`
  .ant-tabs-nav {
    margin-bottom: 0;
  }

  .ant-tabs-tab {
    padding: 6px 12px;
    color: #333;
    border: 1px solid #ccc;
    background-color: #f0f0f0;
    font-size: 14px;
  }

  .ant-tabs-tab:not(:first-of-type) {
    margin: 0 0 0 8px !important;
  }

  .ant-tabs-tab-active {
    background-color: var(--blue-dark-color, #001529);
    border: 1px solid var(--blue-dark-color, #001529);
    .ant-tabs-tab-btn {
      color: #ffffff !important;
      font-weight: 500;
    }
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab:hover {
    color: #333 !important;
  }
`;

const headerBarBoxStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 16px;
`;

const headerTitleStyle = css`
  margin: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #000000 !important;
  line-height: 1.4 !important;
`;
